import React from "react";
import Section from "../components/Section";
import ResumePDF from "../assets/Prashant Resume.pdf";
import PSCartoon from "../assets/prashant_cartoon.png";
import {
  FaGithub,
  FaLinkedinIn,
  FaTwitter,
} from "react-icons/fa";
import {SiLeetcode} from "react-icons/si"

const SocialIcon = ({ href, icon }) => {
  return (
    <a
      className="social-icon"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
    >
      {icon}
    </a>
  );
};

export default function Home() {
  const icons = [
    {
      href: "https://www.linkedin.com/in/prashant-singh-1428aa205",
      icon: <FaLinkedinIn />,
    },
    {
      href: "https://github.com/PrashantS360",
      icon: <FaGithub />,
    },
    {
      href: "https://twitter.com/Prashant_360",
      icon: <FaTwitter />,
    },
    {
      href: "https://leetcode.com/prashant360",
      icon: <SiLeetcode />,
    }
  ];

  return (
    <Section id="about">
      <div className="row justify-content-between">
        <div className="col-md-6 order-last order-lg-first" data-aos="fade-up">
          <h1 className="mb-0">
            Prashant
            <span className="text-primary" style={{ paddingLeft: "2vw" }}>
              Singh
            </span>
          </h1>
          <div className="subheading mb-3">
            {/* <span style={{paddingRight: '0.3vw'}}>
              Impossible is nothing!
            </span> */}
            {/* <span style={{ paddingRight: "0.3vw" }}>·</span> */}
            <a href="mailto:prashantsingh5aug@gmail.com" className="home-mail">
              prashantsingh5aug@gmail.com
            </a>
          </div>
        </div>
        <div className="col-md-3 mb-5 mb-lg-0" data-aos="fade-up">
          <img
            src={PSCartoon}
            alt="Prashant Cartoon"
            style={{ height: "40vh", width: "40vh" }}
          />
        </div>
      </div>

      <p className="lead mb-4">
        I am a third-year undergraduate, Electronics and Communication Student
        at IIIT Jabalpur. I am a full stack developer with robust
        problem-solving skill. Being a technology enthusiast, I
        keep myself updated with new trends in programming world. I have a keen
        interest towards learning new concepts.
      </p>

      <div className="btn-group mb-5">
        <button
          className="btn btn-primary btn-custom py-2 px-5 CV-Button"
          type="submit"
          onClick={() => window.open(ResumePDF)}
        >
          View CV
        </button>
      </div>

      <div className="social-icons">
        {icons.map(({ href, icon }, index) => (
          <SocialIcon href={href} icon={icon} key={index} />
        ))}
      </div>
    </Section>
  );
}
